import React from 'react'
import Chrome, { ChromeProps } from '../Chrome'
import { useLeadForChatWidgetQuery } from '#src/generated/graphql'

interface ChromeWithLeadSidebarProps extends ChromeProps {
  leadId: string
}

const ChromeWithLeadSidebar: React.SFC<ChromeWithLeadSidebarProps> = ({ leadId, ...props }) => {
  const { data: leadData } = useLeadForChatWidgetQuery({
    variables: { leadId: leadId }
  })

  // If you already have a lead with a conversation, we'll re-use that conversation
  const lead = leadData && leadData.lead
  const existingConversationId = lead && lead.conversation.id
  const existingLeadExpertId = lead && lead.expert.id

  return (
    <Chrome
      sidebar={true}
      chatConversationId={existingConversationId || undefined}
      chatExpertId={existingLeadExpertId}
      {...props}
    />
  )
}

export default ChromeWithLeadSidebar
